<div class="grid" *ngIf="!cargaInicial">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
    <span>{{'LBL_CONSULTANDO' | translate }}</span>
  </div>
</div>

<div *ngIf="cargaInicial">
  <div class="grid">
    <div class="col-12 md:col-12 lg:col-12">
      <h1 class="titulo-pagina">{{ 'PRODUCTOSALERTA.LBL_PRODUCTOSALERTA' | translate }}</h1>
    </div>
  </div>

  <div *ngIf="errorConfiguracion">
    <div class="grid">
      <div class="col-12 md:col-12 lg:col-12 text-center" style="background-color: red; border-radius: 8px; color: #fff;">
        {{ 'MSG_FALTACONFIGURACION' | translate }}
      </div>
    </div>
  </div>

  <div *ngIf="!errorConfiguracion && !editando">
    <div class="grid" *ngIf="!visualizar">
      <div class="col-12 md:col-6 lg:col-6">
        <button type="button" pButton icon="fa fa-plus" (click)="agregarNuevaAlerta()"
                label="{{ 'PRODUCTOSALERTA.BTN_AGREGAR' | translate}}"></button>
      </div>
      <div class="col-12 md:col-6 lg:col-6">
        <input #gb type="text" pInputText size="40" placeholder="{{ 'LBL_BUSCAR' | translate }}"
               (input)="dt.filterGlobal($event.target.value, 'contains')"
               [(ngModel)]="busqueda" (change)="setBusqueda()">
      </div>
    </div>

    <div class="grid">
      <div class="col-12 md:col-12 lg:col-12">
        <p-table [totalRecords]="numRegistros" #dt
                 selectionMode="single"
                 [columns]="columnas" [loading]="buscando"
                 [value]="listaProductoAlertas"
                 [paginator]="true" [rows]="10"  paginatorPosition="bottom">
          <ng-template pTemplate="header" let-columns>
            <tr>
              <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" class="text-center">
                {{col.header}}
                <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-row>
            <tr [pSelectableRow]="row">
              <td class="text-center">{{row.codigoAlerta}}</td>
              <td class="text-center">
                <p-checkbox [(ngModel)]="row.indicadorNoAplica" binary="true" disabled="true"></p-checkbox>
              </td>
              <td class="text-center">
                <p-checkbox [(ngModel)]="row.indicadorHabilitado" binary="true" disabled="true"></p-checkbox>
              </td>
              <td class="text-center">
                <div>
                  <div class="btn-group" role="group">
                    <button type="button" class="p-button btn" icon="fa fa-pencil" data-toggle="tooltip"
                            title="{{'BTN_EDITAR' | translate}}" *ngIf="!visualizar"
                            pButton (click)="editarAlerta(row)"></button>

                    <button type="button" class="p-button btn" icon="fa fa-eye" data-toggle="tooltip"
                            title="{{'BTN_VISUALIZAR' | translate}}" *ngIf="visualizar"
                            pButton (click)="editarAlerta(row)"></button>
                  </div>
                </div>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage" let-columns>
            <tr>
              <td [attr.colspan]="columns.length" class="text-center">
                {{ 'MSG_NOHAYREGISTROS' | translate}}
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>

  <div *ngIf="!errorConfiguracion && editando">
    <div class="grid">
      <div class="col-12 md:col-12 lg:col-12">
        <app-producto-alertas-editar
          [producto]="producto"
          [visualizar]="visualizar"
          [idProductoAlerta]="idProductoAlertaEditar"
          (regresarListado)="mostrarListado($event)"></app-producto-alertas-editar>
      </div>
    </div>
  </div>
</div>

<p-confirmDialog #cd>
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>
